import { Button, Modal } from "react-bootstrap";
import crossIcon from "Assets/images/cross_icon.png";
import styles from "./DuplicateSchoolClientModal.module.scss";
import CommonButton from "components/shared/FormComponents/V2/commonV2/CommonButton";
import { dateFormat } from "helpers/common";

const DuplicateSchoolClientModal = ({
  show,
  matches = [],
  onCancel,
  onCreateAnyway,
  onViewClient,
  isCreating = false,
}) => (
  <Modal
    show={show}
    className={`${styles.duplicateClientModal} transparentModal common-confirmation-modal modal-v2`}
    onHide={onCancel}
    backdrop="static"
    keyboard={false}
    centered
  >
    <Modal.Body className={styles.modalBody}>
      <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
        <h3 className={`${styles.title} mb-0 section-title border-bottom-0`}>Possible Duplicate Client</h3>
        <img onClick={onCancel} width={16} height={16} src={crossIcon} alt="Close" className={styles.closeIcon} />
      </div>

      <p className={styles.message}>
        A client with the same first name, last name, and date of birth already exists.
      </p>

      <div className={styles.matches}>
        {matches.map((client) => (
          <div key={client.id} className={styles.match}>
            <div>
              <div className={styles.clientName}>{client.firstname} {client.lastname}</div>
              <div className={styles.clientDetails}>
                DOB: {client.dob ? dateFormat(client.dob, "MMM DD, YYYY") : ""}
                {client.grade ? ` • Grade: ${client.grade}` : ""}
                {client.status ? ` • ${client.status}` : ""}
              </div>
            </div>
            <CommonButton text="View Client" style={{border: 'none', textDecoration: 'underline'}} className={styles.viewButton} onClick={() => onViewClient(client.id)}>
            </CommonButton>
          </div>
        ))}
      </div>

      <div className={styles.actions}>
        <CommonButton text="Cancel" className={styles.cancelButton} onClick={onCancel}>
        </CommonButton>
        <CommonButton  style={{ color: "#fff", background: "#315D99" }} text="Create Anyway" onClick={onCreateAnyway} disabled={isCreating}>
        </CommonButton>
      </div>
    </Modal.Body>
  </Modal>
);

export default DuplicateSchoolClientModal;
